module.exports = __webpack_public_path__ + "static/0010-73061346adf467b42a71501f116b6ece.png";